<template lang="html">
  <v-content>
    <v-container>
      <v-layout column align-center justify-center>
        <div id="error-message"></div>
        <div id="card-errors"></div>
        <!-- <v-alert :value="true" width="500" class="mb-4" v-if="currentUser.is_advisor">
          Message for Admin: Currently admin cannot switch primary cards through Soraban Webapp. It can only be done through Stripe Dashboard.
        </v-alert> -->
        <v-card
          flat
          width="500"
          :height="isEmpty(this.primaryCard) ? 150 : 350"
          class="content-container"
        >
          <v-card-title class="title">
            Current Primary Card
            <v-spacer />
            <v-btn @click="update" class="primary text-capitalize">
              Add Primary Card
            </v-btn>
          </v-card-title>
          <v-divider class="separator" />
          <v-layout class="card-wrapper justify-center align-center mt-4">
          </v-layout>
          {{ message }}
          <form>
            <!-- <input type="text" name="number">
            <input type="text" name="name"/>
            <input type="text" name="expiry"/>
            <input type="text" name="cvc"/> -->
          </form>
        </v-card>
        <!-- <v-layout wrap>
          <v-flex xs6 v-for="card in cards" class="py-2 px-2">
            <v-card>
              <v-card-title>
                <v-layout class="title justify-center">
                  **** **** **** {{card.last4}} ({{card.brand}})
                </v-layout>
              </v-card-title>
              <v-card-text>
                <v-layout class="justify-center align-center">
                  Expiration Valid Thru > {{card.exp_month}}/{{card.exp_year}} <v-chip v-if="card.default" class="primary white--text">Primary</v-chip>
                </v-layout>
              </v-card-text>
            </v-card>
          </v-flex>
        </v-layout> -->
      </v-layout>
    </v-container>
  </v-content>
</template>
<script src="https://js.stripe.com/v3/"></script>

<script>
import { firebase } from '@firebase/app';
import '@firebase/auth';
import API from '@/api';
import { mapGetters } from 'vuex';
import isEmpty from 'lodash/isEmpty';

export default {
  name: 'UpdatePayment',
  components: {},
  data: () => ({
    loading: false,
    primaryCard: {},
    message: '',
  }),
  computed: {
    ...mapGetters({
      currentUser: 'user',
    }),
    currentSelectedUserId() {
      return this.currentUser.default_company.user_id;
    },
  },
  methods: {
    async update() {
      const stripe = await Stripe(process.env.STRIPE_PUBLISHABLE_KEY);
      const response = await API.user.startStripeSession({
        userId: this.currentSelectedUserId,
      });

      const { error } = await stripe.redirectToCheckout({
        // Make the id field from the Checkout Session creation API response
        // available to this file, so you can provide it as parameter here
        // instead of the {{CHECKOUT_SESSION_ID}} placeholder.
        sessionId: response.data.session_id,
      });
    },
    async updateDefaultPayment() {
      const response = await API.user.getAllPaymentMethods({
        userId: this.currentSelectedUserId,
      });
      this.primaryCard = response.data.cards.find(c => c.default);
      if (this.primaryCard) {
        new Card({
          form: 'form',
          container: '.card-wrapper',
          placeholders: {
            number: `•••• •••• •••• ${this.primaryCard.last4}`,
            name: this.currentUser.is_advisor
              ? '-'
              : this.currentUser.full_name,
            expiry: `${this.primaryCard.exp_month}/${this.primaryCard.exp_year}`,
            cvc: '***',
          },
        });
      } else {
        this.message =
          'No Primary Card. Please contact the support team if you face any issues.';
      }
    },
    isEmpty,
  },
  async created() {
    if (this.$route.query.hasOwnProperty('session_id')) {
      try {
        this.$store.commit('application/START_LOADING');
        const response = await API.user.updateCard({
          sessionId: this.$route.query.session_id,
        });
        this.$router.replace('update-payment');
        this.$store.dispatch('application/setSuccessNotification', {
          message: 'Successfully updated your default payment method',
        });
      } catch (e) {
        this.$store.dispatch('application/setErrorNotification', {
          message:
            'Something went wrong while updating your default payment method. Please contact the support team.',
        });
      } finally {
        this.$store.commit('application/END_LOADING');
      }
    }
    this.updateDefaultPayment();
    // if (this.currentUser.paying) {
    //   this.$router.push('/');
    // }
  },
};
</script>

<style lang="postcss" scoped>
.package-card {
  padding: 15px;
  border-radius: 0px;
  box-shadow: 0 8px 32px #e7ebf6;
  &--basic {
  }
  &--advanced {
    color: white !important;
    background-color: #0081f6 !important;
  }
  &--advanced-partnership {
    background: linear-gradient(65deg, #ff9083 0, #ff6250 100%) !important;
    color: white !important;
  }
  &--hover {
    box-shadow: 0 25px 70px #0081f650;
  }
}
.subscribe-button {
  /* padding: 12px 16px; */
  border: 0;
  border-radius: 2px;

  &--basic {
    background: linear-gradient(65deg, #ff9083 0, #ff6250 100%) !important;
    color: white !important;
  }
  &--advanced {
    background: linear-gradient(65deg, #fff 0, #deefff 100%);
    color: #0081f6 !important;
  }
  &--advanced-partnership {
    background: linear-gradient(65deg, #fff 0, #deefff 100%);
    color: #0081f6 !important;
  }
}
</style>
